import { Grid, TextField, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FormProvider, useForm } from "react-hook-form";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import service from "../Helpers/gifservices";
import { setData, setServiceFunction } from "../../../store/formSlice";
import {
  canEditSelector,
  refereeSelector,
  refereeStatusSelector,
  setRefereeStatus,
} from "../../../store/refereeSlice";
import { useLoading } from "../../../providers/loadingProvider";
import { checkDetaliedEvaluation } from "../Helpers/common";

const pageName = "Detailed Evaluation";

const fields = {
  evaluation: "detailedEvaluation",
};

const DetailedEvaluation = (props) => {
  const methods = useForm();
  const loading = useLoading();
  const dispatch = useDispatch();
  const referee = useSelector(refereeSelector);
  const refereeStatus = useSelector(refereeStatusSelector);
  const canEdit = useSelector(canEditSelector);
  const [proposalRefereeId, setProposalRefereeId] = useState(null);
  const [proposalReferee, setProposalReferee] = useState({});
  const [detailedEvaluation, setDetailedEvaluation] = useState("");

  useEffect(() => {
    setProposalRefereeId(referee?.id);
  }, [referee]);

  const detailedEvaluationChange = (event) => {
    setDetailedEvaluation(event.target.value);
    const newpr = {
      ...proposalReferee,
      detailedEvaluation: event.target.value,
    };
    dispatch(
      setData({
        proposalReferee: newpr,
      })
    );
  };

  const GetProposalReferee = useCallback(async () => {
    if (!proposalRefereeId) return;
    const loadingId = loading.addLoading("Loading Proposal");
    var proposalreferee = await service.GetProposalRefereeById({
      proposalRefereeId,
    });
    setProposalReferee(proposalreferee);
    if (proposalreferee.detailedEvaluation)
      setDetailedEvaluation(proposalreferee.detailedEvaluation);
    dispatch(
      setData({
        proposalReferee: proposalreferee,
      })
    );
    loading.removeLoading(loadingId);
  }, [proposalRefereeId, dispatch, loading]);

  useEffect(() => {
    dispatch(setServiceFunction(`UpdateRefereeRecommendation`));
  }, [dispatch]);

  useEffect(() => {
    GetProposalReferee();
  }, [GetProposalReferee, proposalRefereeId]);

  useEffect(() => {
    return () => {
      if (!detailedEvaluation || detailedEvaluation === "" || !proposalReferee)
        return;
      if (proposalReferee.detailedEvaluation !== detailedEvaluation) {
        const newProposalReferee = {
          ...proposalReferee,
          detailedEvaluation: detailedEvaluation,
        };
        const detailedEvaluationStatus =
          checkDetaliedEvaluation(newProposalReferee);
        if (refereeStatus.detaliedEvaluation !== detailedEvaluationStatus)
          dispatch(
            setRefereeStatus({
              ...refereeStatus,
              detaliedEvaluation: detailedEvaluationStatus,
            })
          );
      }
    };
  }, [detailedEvaluation, proposalReferee, dispatch, refereeStatus]);

  return (
    <>
      <FormProvider {...methods}>
        <form>
          <Grid container spacing={2}>
            <Grid item>
              <Typography variant="subtitle2">{pageName}</Typography>
            </Grid>
            <Grid item>
              <InfoOutlinedIcon color="primary" />
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
              >
                In your detailed evaluation, please attend to the following
                criteria:
              </Typography>
              <Typography>
                <ol>
                  {[
                    "Scientific quality of the proposed approach",
                    "Adequacy of methods",
                    "Originality  and novelty of the project",
                    "Suitability of the investigators' scientific background to the project",
                    <><b>Collaboration track (2 PIs or more):</b> Feasibility for achieving the goals through the described collaboration between the PIs and mode of cooperation between the teams<br/>
                    <b>Solo track (1 PI only):</b> Feasibility for achieving the goals during the duration of the grant and feasibility for future cooperation</>,
                    "Adequacy of the budget and the estimated time frame for the project",
                    "Summary (strengths / weaknesses) of the proposal",
                  ].map((t) => (
                    <li>{t}</li>
                  ))}
                </ol>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                Please enter your evaluation in the box below: (Please note: This part <b>will
                be sent</b> to the applicant/s)
              </Typography>
              <TextField
                multiline
                label="Evaluation"
                onChange={detailedEvaluationChange}
                value={detailedEvaluation}
                name={fields.evaluation}
                disabled={!canEdit}
                fullWidth={true}
                rows={6}
              />
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </>
  );
};

export default DetailedEvaluation;
